import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BehaviorSubject, from, interval, Observable, of} from 'rxjs';
import {ConfigsLoaderService} from './config-loader.service';
import {AuthService} from './auth.service';
import {filter, startWith, switchMap, tap} from 'rxjs/operators';
import { GetReportFile, ReportNotification } from 'app/models/generate-report.model';
import * as saveAs from 'file-saver';
import { off } from 'process';
import { ReportType } from 'app/enums/report-panel.enum';

@Injectable({
    providedIn: 'root'
})
export class ReportService {

    private readonly useMockData = false;
    private readonly apiEndpoint: string;
    private reportsSubject = new BehaviorSubject<any[]>([]);
    get reports$() {
      return this.reportsSubject.asObservable();
    }
    private refresh$ = new BehaviorSubject<void>(null);

    constructor(
        private httpClient: HttpClient,
        private config: ConfigsLoaderService,
        private authService: AuthService,
    ) {
        this.apiEndpoint = this.config.apiUrl;

        this.authService.currentUser$.subscribe(
          user => {
            user?.permissions.map(x => {
              if(x.id == (ReportType.ReportAlert || ReportType.ReportCase || ReportType.ReportComplaint)){
                
                this.authService.currentUser$
              .pipe(
                switchMap(user => {
                  
                  // Cambiar 'notificationInterval' por variable de notificaciones (cuando este disponible)
                  return interval(user?.['reportInterval'] || (5 * 60 * 1000))
                    .pipe(startWith(null)); // startWith - So that it doesn't wait the first interval
                }),
                switchMap(() => this.refresh$),
                switchMap(() => this.authService.isLoggedIn()),
                filter(isLoggedIn => isLoggedIn),
                switchMap(() => {
                    return this.getReports();
                }),
              ).subscribe(this.reportsSubject);
              }
            });
          }
        )
        

    }

    getReports(): Observable<ReportNotification[]> {
      return from(this.authService.isLoggedInAndAuthorized())
      .pipe(
        switchMap(isLoggedIn => {
          if (isLoggedIn){
            return this.httpClient.get<ReportNotification[]>(`${this.apiEndpoint}/Report/GetAll`);
          }
        })
      );
    }

    downloadFileReport(getReport: GetReportFile) {
      return this.httpClient
        .post<{ data: string, mimeType: string, fileName: string }>(`${this.apiEndpoint}/Report/Download`, getReport)
        .pipe(
          tap(data => {
            fetch(`data:${data.mimeType};base64,${data.data}`)
              .then(res => res.blob())
              .then(blob => saveAs(blob, data.fileName));
          }),
        );
    }

}

